import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormCheckbox from "./FormCheckbox";
import { ControllerProps } from "react-hook-form";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import { CheckboxProps } from "@mui/material";
import { FormProps } from "./FormProps";

function FormCheckboxTC(
  props: FormProps & Translation & { rules?: ControllerProps["rules"] } & { fieldProps?: CheckboxProps }
) {
  return (
    <FormFieldTwoColumns {...props} gridSizes={props.gridSizes ?? { column1: { xs: 4 }, column2: { xs: 8 } }}>
      <FormCheckbox name={props.name} />
    </FormFieldTwoColumns>
  );
}

FormCheckboxTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  label: PropTypes.oneOf([PropTypes.element, PropTypes.string]), // FormField props
};

export default FormCheckboxTC;
